package com.mgacreative.hotel.feature.inventory.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.domain.repository.InventoryItem
import com.mgacreative.hotel.domain.repository.InventoryRepository
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

class InventoryViewModel(
    private val inventoryRepository: InventoryRepository
) : ViewModel() {

    val items: StateFlow<List<InventoryItem>> = inventoryRepository.observeInventoryItems()
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000),
            initialValue = emptyList()
        )

    init {
        viewModelScope.launch {
            inventoryRepository.loadInventoryItems()
        }
    }

    fun addItem(name: String, category: String, quantity: Int, minThreshold: Int, unit: String) {
        viewModelScope.launch {
            inventoryRepository.addInventoryItem(name, category, quantity, minThreshold, unit)
        }
    }

    fun updateItem(item: InventoryItem) {
        viewModelScope.launch {
            inventoryRepository.updateInventoryItem(item)
        }
    }

    fun deleteItem(itemId: String) {
        viewModelScope.launch {
            inventoryRepository.deleteInventoryItem(itemId)
        }
    }

    fun addTransaction(itemId: String, type: String, quantity: Int, description: String? = null) {
        viewModelScope.launch {
            inventoryRepository.addTransaction(itemId, type, quantity, description)
        }
    }
}
